export default __webpack_public_path__ + "static/media/johnson.97f05127.png";